import request from '@/utils/request'
const api = {
  getList: 'user_message/getList'
}
export default {
  getList(parameter) {
    return request({
      url: api.getList,
      method: 'POST',
      data: parameter
    })
  }
}
